<div class="main-section loader-page">
    <div class="content-wrapper">
        <img src="https://images.5paisa.com/SPOT/5p_loan/loader.gif" alt="loader" />
        <p>You are getting redirected</p>
    </div>
</div>
